import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import SectionWrapper from "../../components/SectionWrapper/SectionWrapper";

import AgingReportForm
  from "../../modules/receivable/aging/components/AgingReportForm";

const AgingReportCxcPage = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <SectionWrapper>
        <AgingReportForm />
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default AgingReportCxcPage;